export const Routes = {

    // authen
    Signin: { path: "/login-in" },
    Signup: { path: "/sign-up" },
    ForgotPassword: { path: "/forgot-password" },
    ResetPassword: { path: "/reset-password" },
    ServerError: { path: "/server-error" },

    // trang chủ
    Overview: { path: "/" },
    CustomerOverview: { path: "/customer" },
    SettingOverview: { path: "/setting" },
    VietlottOverview: { path: "/vietlott" },
    ClassicMNOverview: { path: "/classic-mn" },
    ClassicMTOverview: { path: "/classic-mt" },
    ClassicMBOverview: { path: "/classic-mb" },
    LotoOverview: { path: "/loto" },

    // CUSTOMER
    CustomerAddCharge: { path: "/customer/charge" },
    CustomerChargeHistory: { path: "/customer/charge/history" },
    CustomerIssueCharge: { path: "/customer/charge/issue-charge" },
    CustomerChargeSummary: { path: "/customer/charge/summary" },
    CustomerChargeSettings: { path: "/customer/charge/settings" },
    CustomerRefund: { path: "/customer/refund" },
    CustomerRefundHistory: { path: "/customer/refund/history" },
    CustomerCashbackHistory: { path: "/customer/cashback/history" },
    CustomerMoneyLogLink: { path: "/customer/money-log" },
    CustomerMoneyLogHistory: { path: "/customer/money-log/history" },
    
    CustomerWithdrawSettings: { path: "/customer/withdraw/settings" },
    CustomerWithdrawRequest: { path: "/customer/withdraw" },
    CustomerWithdrawRequestConfirmed: { path: "/customer/withdraw/confirmed" },
    CustomerWithdrawSummary: { path: "/customer/withdraw/summary" },
    
    CustomerFirstAgent: { path: "/customer/account/first-agent" },
    CustomerSecondAgent: { path: "/customer/account/second-agent" },
    CustomerCollaborators: { path: "/customer/account/collaborator" },
    CustomerUser: { path: "/customer/account/user" },
    CustomerNewUserSummary: { path: "/customer/new-user-summary" },

    // VIETLOTT
    VietlottCart: { path: "/vietlott/search/cart" },
    VietlottTicket: { path: "/vietlott/search/ticket" },
    VietlottTicketDetail: { path: "/vietlott/search/ticket/:id" },
    VietlottGroup: { path: "/vietlott/search/group" },
    VietlottGroupDetail: { path: "/vietlott/search/group/:id" },
    VietlottGroupPending: { path: "/vietlott/search/group/pending" },
    VietlottGroupActive: { path: "/vietlott/search/group/active" },
    VietlottGroupCompleted: { path: "/vietlott/search/group/completed" },
    VietlottGroupRewarded: { path: "/vietlott/search/group/rewarded" },
    VietlottGroupCancelled: { path: "/vietlott/search/group/cancelled" },
    VietlottGroupCreate: { path: "/vietlott/search/group/create" },
    VietlottLotto535Period: { path: "/vietlott/period/lotto535-period" },
    VietlottLotto535Result: { path: "/vietlott/result/lotto535" },
    VietlottKenoResult: { path: "/vietlott/result/keno" },
    VietlottPowerResult: { path: "/vietlott/result/power" },
    VietlottMegaResult: { path: "/vietlott/result/mega" },
    VietlottMax3dResult: { path: "/vietlott/result/max3d" },
    VietlottMax3dProResult: { path: "/vietlott/result/max3d-pro" },
    VietlottWaitingTicket: { path: "/vietlott/statistic/waiting-ticket" },
    VietlottPrintedTicket: { path: "/vietlott/statistic/printed-ticket" },
    VietlottDoneTicket: { path: "/vietlott/statistic/done-ticket" },
    VietlottDeletedTicket: { path: "/vietlott/statistic/deleted-ticket" },
    VietlottTransactionSummary: { path: "/vietlott/statistics/transaction-summary" },
    VietlottTransactionList: { path: "/vietlott/statistics/transaction-list" },
    VietlottTicketSourceSummary: { path: "/vietlott/statistics/ticket-source-summary" },
    VietlottCashBack: { path: "/vietlott/statistics/cashback" },
    VietlottReward: { path: "/vietlott/reward/reward" },
    VietlottBigReward: { path: "/vietlott/reward/big-reward" },
    VietlottDayOff: { path: "/vietlott/period/day-off" },
    VietlottKenoPeriod: { path: "/vietlott/period/keno-period" },
    VietlottPowerPeriod: { path: "/vietlott/period/power-period" },
    VietlottMegaPeriod: { path: "/vietlott/period/mega-period" },
    VietlottMax3dPeriod: { path: "/vietlott/period/max3d-period" },
    VietlottMax3dProPeriod: { path: "/vietlott/period/max3d-pro-period" },

    // CLASSIC
    ClassicListReward: { path: "/classic-common/list-reward" },
    ClassicRegion: { path: "/classic-common/region" },
    ClassicMNChannel: { path: "/classic/mn/channel" },
    ClassicMTChannel: { path: "/classic/mt/channel" },
    ClassicMNTicketSales: { path: "/classic/mn/ticket-sales" },
    ClassicMTTicketSales: { path: "/classic/mt/ticket-sales" },
    ClassicMBTicketSales: { path: "/classic/mb/ticket-sales" },
    ClassicMNReward: { path: "/classic/mn/reward" },
    ClassicMNBigReward: { path: "/classic/mn/big-reward" },
    ClassicMTReward: { path: "/classic/mt/reward" },
    ClassicMTBigReward: { path: "/classic/mt/big-reward" },
    ClassicMBReward: { path: "/classic/mb/reward" },
    ClassicMBBigReward: { path: "/classic/mb/big-reward" },
    ClassicCart: { path: "/classic-track/cart" },
    ClassicTicket: { path: "/classic/ticket" },
    ClassicResult: { path: "/classic/result" },
    ClassicTicketStorage: { path: "/classic/ticket-storage" },
    ClassicStatistic: { path: "/classic/statistic" },
    ClassicStatisticByTicket: { path: "/classic/statistic-by-ticket" },
    ClassicStatisticByUnmarketableTicket: { path: "/classic/statistic-by-unmarketable-ticket" },
    ClassicMNPeriod: { path: "/classic/mn/period" },
    ClassicMTPeriod: { path: "/classic/mt/period" },
    ClassicMBPeriod: { path: "/classic/mb/period" },
    ClassicMNNewCart: { path: "/classic/mn/new-cart" },
    ClassicMTNewCart: { path: "/classic/mt/new-cart" },
    ClassicMBNewCart: { path: "/classic/mb/new-cart" },
    ClassicMNDoneCart: { path: "/classic/mn/done-cart" },
    ClassicMTDoneCart: { path: "/classic/mt/done-cart" },
    ClassicMBDoneCart: { path: "/classic/mb/done-cart" },
    ClassicMNSearch: { path: "/classic/mn/search" },
    ClassicMTSearch: { path: "/classic/mt/search" },
    ClassicMBSearch: { path: "/classic/mb/search" },

    // LOTO
    LotoChannel: { path: '/loto/channel' },
    LotoPeriod: { path: "/loto/period" },
    LotoSearch: { path: "/loto/search" },
    LotoDoneCart: { path: "/loto/done-cart" },
    LotoNewCart: { path: "/loto/new-cart" },
    LotoReward: { path: "/loto/reward" },
    LotoBigReward: { path: "/loto/big-reward" },
    LotoStatisticByTicket: { path: "/loto/statistic-by-ticket" },

    // SETTING
    SettingDevices: { path: "/setting/devices" },
    SettingGames: { path: "/setting/games" },
    SettingBanner: { path: "/setting/banner" },
    SettingPaymentMethod: { path: "/setting/payment-method" },
    SettingAccount: { path: "/setting/account" },
    SettingBank: { path: "/setting/bank" },
    SettingNotification: { path: "/setting/notification" },
    SettingPrivacy: { path: "/setting/privacy" },
    SettingGameGuide: { path: "/setting/game-guide" },
    SettingContact: { path: "/setting/contact" },
    SettingInvite: { path: "/setting/invite" },
    SettingSystemNotification: { path: "/setting/system-notification" },
    SettingMaintained: { path: "/setting/maintained" },
    SettingTicketRoll: { path: "/setting/ticket-roll" },
    SettingWorkerQueue: { path: "/setting/worker-queue" },
    SettingServerBenchmark: { path: "/setting/server-benchmark" },
    SettingEmployee: { path: "/setting/employee" },

    AdminManagement: { path: "/admin/management" },
    TicketEmployeeManagement: { path: "/admin/ticket-employees" },

    // ANOTHER
    MBRefund: { path: "/management/mb-refund" },
    MBDoisoat: { path: "/management/mb-doisoat" },
    NotFound: { path: '/not-found' }
};